import {Element} from "@craftjs/core";
import {Accordion} from "@/src/components/Accordion";
import {Title} from "@/src/components/Title";
import {FlexBox} from "@/src/components/FlexBox";
import {Collapses} from "@/src/components/Collapses";
import { Card } from "@/src/components/Card";
import IntroSection from "@/src/components/pages/HomePage/components/IntroSection";

export function FaqList(props: any) {
    return <IntroSection/>
    return (
        <Element
            is={Card}
            canvas
            {...{
                style: {
                    "box-shadow": "0px 1px 6px 0px rgba(0, 0, 0, 0.12)",
                    gap: "16px",
                    borderRadius: "8px",
                    background: "#FFFFFF",
                    padding: "32px",
                },
            }}
            id={"FaqList"}
        >
            <Element is={FlexBox} style={{ flexDirection: "column", gap: 24 }} canvas>
                <Element is={Title} text={"Пам’ятка до полісу:"} size={"h3"} />
                <Element
                    is={Accordion}
                    items={[
                        {
                            label: "Коли потрібно друкувати поліс?",
                            value: "when-to-print",
                        },
                        {
                            label: "Де я можу почитати правила страхування та оферти?",
                            value: "where-to-read",
                        },
                        {
                            label: "Що робити при настанні страхового випадку?",
                            value: "what-to-do",
                        },
                        {
                            label: "Коли потріюно мати з собою поліс?",
                            value: "when-to-have",
                        },
                    ]}
                />
                <Element
                    is={Collapses}
                    titleOpen={"Показати більше"}
                    titleClose={"Приховати"}
                />
            </Element>
        </Element>
    );
}
